/**
 * Active request context
 *
 * Browsers have no AsyncLocalStorage, so the ActionOrchestrator registers the
 * client request id of each in-flight `execute()` here. Low-level code (the
 * http client) can then tag its log lines with the id of the action that
 * caused the call, without every service having to thread it through.
 *
 * When several actions run concurrently the owner of a given call is
 * ambiguous, so no id is returned rather than a wrong one.
 */

const activeRequestIds = new Set<string>();

export function beginRequest(requestId: string): void {
  activeRequestIds.add(requestId);
}

export function endRequest(requestId: string): void {
  activeRequestIds.delete(requestId);
}

/** The request id of the single in-flight action, or undefined. */
export function getActiveRequestId(): string | undefined {
  if (activeRequestIds.size !== 1) return undefined;
  return activeRequestIds.values().next().value;
}
